var moduleMap = {
	"./Dashboard": () => {
		return Promise.all([__webpack_require__.e(298), __webpack_require__.e(43), __webpack_require__.e(262), __webpack_require__.e(771)]).then(() => (() => ((__webpack_require__(17771)))));
	},
	"./Profile": () => {
		return Promise.all([__webpack_require__.e(298), __webpack_require__.e(262), __webpack_require__.e(616)]).then(() => (() => ((__webpack_require__(77616)))));
	},
	"./Settings": () => {
		return Promise.all([__webpack_require__.e(298), __webpack_require__.e(262), __webpack_require__.e(736)]).then(() => (() => ((__webpack_require__(95736)))));
	},
	"./mount": () => {
		return Promise.all([__webpack_require__.e(298), __webpack_require__.e(43), __webpack_require__.e(424), __webpack_require__.e(262), __webpack_require__.e(771), __webpack_require__.e(449)]).then(() => (() => ((__webpack_require__(38449)))));
	},
	"./HostBridge": () => {
		return __webpack_require__.e(451).then(() => (() => ((__webpack_require__(55451)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});